// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"ev-info-card_cardContainer__VMPwg","iconTitleContainer":"ev-info-card_iconTitleContainer__arg7j","text":"ev-info-card_text__KwoSK"};